<template>
  <el-dialog
    title="发送题目到模板"
    :visible.sync="visible"
    :close-on-click-modal="false"
    width="500px"
    @keyup.enter.native="onSubmit()">
    <el-form :model="form"
             status-icon
             :rules="rules"
             ref="form"
             label-width="120px">
      <el-form-item label="来源题目"
                    v-html="question.title"
                    prop="pass">
      </el-form-item>
      <el-form-item label="目标模板"
                    prop="substep_id">
        <remote-select
          class="width-max"
          clearable
          id-key="id"
          label-key="title"
          value-key="id"
          placeholder="请输入分步任务模板关键字"
          v-model="form.substep_id"
          :query-request="getStepTemplateTable"
          @change="change">
        </remote-select>
      </el-form-item>
      <el-form-item label="目标题目"
                    prop="index">
        <el-select class="width-max"
                   v-model="form.index"
                   placeholder="请选择题目"
                   :disabled="!form.substep_id">
          <el-option
            v-for="(question, index) in toQuestions"
            :key="index"
            :label="`Q${index+1} ${stripTags(question.title)}`"
            :value="index"
            :disabled="fixedIds.includes(question.stepId)">
            <div v-html="`Q${index+1} ${question.title}`"></div>
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary"
                 :loading="loading"
                 @click="onSubmit()">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { recoveryQuestions } from '@views/question-editor/format/recovery'
import questions from '@views/question-editor/utils/questions'

export default {
  components: {},
  inject: ['request'],
  props: {
    fixedIds: {
      type: Array,
      default: () => []
    },
  },
  data () {
    return {
      loading: false,
      visible: false,
      stripTags: filter.stripTags,
      rules: {
        substep_id: [
          {required: true, message: '请选择分步模板', trigger: 'change'},
        ],
        index: [
          {required: true, message: '请选择题目', trigger: 'change'},
        ],
      },
      question: {},
      toQuestions: [],
      form: {
        substep_id: null,
        index: null,
      },
    }
  },
  computed: {},
  watch: {
    visible () {
      if (!this.visible) {
        Object.assign(this.$data, this.$options.data())
        this.$nextTick(() => this.$refs.form.clearValidate())
      }
    },
  },
  created () {},
  mounted () {},
  methods: {
    getStepTemplateTable (_) {
      return request(this.request.table, _)
    },
    getStepTemplateDetail (_) {
      return request(this.request.detail, _)
    },
    open (question) {
      this.question = question
      this.visible = true
    },
    change ({id}) {
      this.getStepTemplateDetail({id}).then(({data}) => {
        this.toQuestions = JSON.parse(data.json)
      })
    },
    emptyJumpId (question) {
      if (question.jumpTargetId) question.jumpTargetId = ''
      if (question.options) {
        question.options.forEach((option) => {
          if (option.jumpTargetId) option.jumpTargetId = ''
        })
      }
    },
    emptyReferId (question) {
      if (question.referIds) question.referIds = []
      if (question.options) {
        question.options.forEach((option) => {
          if (option.referIds) option.referIds = []
        })
      }
    },
    resetId (question) {
      question.id = questions.id()
    },
    getForm () {
      let question = filter.copyJson(this.question)
      this.emptyJumpId(question)
      this.emptyReferId(question)
      this.resetId(question)
      this.form.question = JSON.stringify(recoveryQuestions([question])[0])
      return this.form
    },
    onSubmit () {
      this.loading = true
      this.$refs['form'].validate((valid) => {
        if (valid) {
          request.alert('addQuestionToStepTemplate', this.getForm()).then((res) => {
            this.$confirm('发送题目成功,是否前往模板查看？', '提示', {type: 'success'}).then(() => {
              this.$router.push('/step-template/update/' + this.form.substep_id)
            }).finally(() => {
              this.visible = false
            })
          }).finally(() => {
            this.loading = false
          })
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/step-template/components/SendQuestionTo.vue